import RentalProperty from './RentalProperty.yaml?component';
import UcRentalFormProperties from './UcRentalFormProperties.yaml?component';

export { RentalProperty, UcRentalFormProperties };
